import { oroMxSignSourceAssets } from '@/shared/theme/oro-mx-sign-assets';
import { oroMxSignChestAssets } from '@/shared/theme/oro-mx-sign-chest-assets';

const publicBase = import.meta.env.BASE_URL.endsWith('/')
  ? import.meta.env.BASE_URL
  : `${import.meta.env.BASE_URL}/`;
const skin = `${publicBase}skins/oro-mx-h5`;

export type OroMxActivityCard = {
  cta: string;
  id: string;
  image: string;
  title: string;
  to?: string;
};

export type OroMxProfileMenuItem = {
  extra?: string;
  hideArrow?: boolean;
  icon: string;
  id: string;
  label: string;
  to?: string;
};

export type OroMxDepositChip = {
  amount: number;
  bonus?: number;
};

export const oroMxActivityFallbackImage = `${skin}/activity/rescue.png`;

export function resolveOroMxActivityImage(url: string | null | undefined): string {
  if (!url) {
    return oroMxActivityFallbackImage;
  }
  const trimmed = url.trim();
  if (/^(https?:\/\/|data:|blob:)/i.test(trimmed)) {
    return trimmed;
  }
  const normalized = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  if (normalized === publicBase.slice(0, -1) || normalized.startsWith(publicBase)) {
    return normalized;
  }
  return `${publicBase}${normalized.slice(1)}`;
}

export const oroMxActivityCards: OroMxActivityCard[] = [
  { id: 'app', title: 'DESCARGA LA APP Y RECIBE HASTA', image: `${skin}/activity/app-banner-es.png`, cta: 'Participar ahora' },
  { id: 'vip', title: 'SUBE A VIP', image: `${skin}/activity/vip.png`, cta: 'Participar ahora', to: '/vip' },
  { id: 'cashback', title: 'Cashback Semanal VIP', image: `${skin}/activity/cashback.png`, cta: 'Participar ahora', to: '/deposit' },
  { id: 'monthly', title: 'INGRESOS MENSUALES VIP', image: `${skin}/activity/monthly.png`, cta: 'Participar ahora', to: '/vip' },
  { id: 'daily', title: '1% DE DIARIO PÉRDIDAS', image: `${skin}/activity/daily.png`, cta: 'Participar ahora', to: '/deposit' },
  { id: 'rescue', title: '¡RECUPERA', image: `${skin}/activity/rescue.png`, cta: 'Participar ahora', to: '/deposit' },
];

export const oroMxProfileAssets = {
  avatar: `${skin}/profile/avatar.png`,
};

/** 源站 /user/get_default_head_img 的 7 张默认头，已镜像到本地，运行时不请求源站 */
export const oroMxProfileAvatars = [
  `${skin}/profile/head-2.png`,
  `${skin}/profile/head-3.png`,
  `${skin}/profile/head-4.png`,
  `${skin}/profile/head-5.png`,
  `${skin}/profile/head-6.png`,
  `${skin}/profile/head-7.png`,
  `${skin}/profile/head-8.png`,
];

export const oroMxProfileQuick = [
  { id: 'tx', icon: 'icon-btb', label: 'Transacciones', to: '/transaction-records', viewBox: '0 0 34 34' },
  { id: 'bets', icon: 'icon-recod', label: 'Apuestas', to: '/bet-record', viewBox: '0 0 31 34' },
  { id: 'moves', icon: 'icon-datachart', label: 'Movimientos', to: '/account-record', viewBox: '0 0 34 34' },
] as const;

export const oroMxProfileMenu: OroMxProfileMenuItem[] = [
  { id: 'notify', label: 'Notificaciones', icon: `${skin}/profile/notify.png`, to: '/notice' },
  { id: 'withdraw-account', hideArrow: true, label: 'Gestión de cuentas de retiro', icon: `${skin}/profile/withdraw-account.png`, to: '/withdraw-accounts' },
  { id: 'offers', label: 'Mis ofertas', icon: `${skin}/profile/offers.png`, to: '/discount' },
  { id: 'my-profile', label: 'Mi perfil', icon: `${skin}/profile/my-profile.png`, to: '/account/profile/edit' },
  { id: 'team', label: 'Centro de equipo', icon: `${skin}/profile/team.png`, to: '/agent-share' },
  { id: 'tickets', label: 'Ofertas', icon: `${skin}/profile/tickets.png`, to: '/discount' },
  { id: 'settings', label: 'Configuración', icon: `${skin}/profile/settings.png`, to: '/security-settings' },
  { id: 'language', extra: 'MX', label: 'Idioma', icon: `${skin}/profile/language.png` },
];

export const oroMxFooterRelated: Array<{ id: string; label: string; to?: string }> = [
  { id: 'vip', label: 'Club VIP', to: '/vip' },
  { id: 'pwa', label: 'Cómo añadir a la pantalla de inicio', to: '/tutorial' },
];

export const oroMxFooterAbout = [
  'Reglas de usuario',
  'Política de Privacidad',
  'Deslinde de Responsabilidad',
  'Política de Verificación de Identidad (KYC)',
  'Política Antilavado de Dinero',
] as const;

export const oroMxFooterLegal =
  'Queda estrictamente prohibido el juego para menores de edad. Por favor, recuerde que el propósito principal de las apuestas es únicamente el entretenimiento y la diversión. orocasino.mx no está dirigido a niños ni a personas menores de 18 años. Si eres menor de 18 años (o no has alcanzado la mayoría de edad legal para apostar en tu país), por favor no ingreses a este sitio. Los menores deben obtener el permiso de sus padres antes de enviar cualquier información personal (como nombre, correo electrónico o teléfono) al sitio web. El juego puede ser adictivo, por favor juega de manera responsable. Para más información, visita nuestra página de [Juego Responsable].';

export const oroMxDepositAssets = {
  bank: `${skin}/deposit/method-bank.png`,
  coupon: `${skin}/deposit/coupon.png`,
  hot: `${skin}/deposit/hot.png`,
  noBank: `${skin}/deposit/no-bank.png`,
  oxxo: `${skin}/deposit/method-oxxo.webp`,
  paycash: `${skin}/deposit/method-paycash.webp`,
  rowCash: `${skin}/deposit/row-cash.png`,
  rowReward: `${skin}/deposit/row-reward.png`,
  rowTotal: `${skin}/deposit/row-total.png`,
  safe: `${skin}/deposit/safe.png`,
};

export const oroMxScratchCollectKeys = ['chile', 'guitar', 'skull', 'pumpkin', 'ukelele'] as const;

export const oroMxScratchAssets = {
  cards: {
    chile: `${skin}/scratch/chile.png`,
    guitar: `${skin}/scratch/guitar.png`,
    pumpkin: `${skin}/scratch/pumpkin.png`,
    skull: `${skin}/scratch/skull.png`,
    ukelele: `${skin}/scratch/ukelele.png`,
  } as Record<string, string>,
  cover: `${skin}/scratch/cover.png`,
  decorationBottom: `${skin}/scratch/decoration-bottom.png`,
  decorationHeader: `${skin}/scratch/decoration-header.png`,
  frame: `${skin}/scratch/wufu-fd.png`,
  rulesLetters: `${skin}/scratch/rules-letters.png`,
  title: `${skin}/scratch/ticket-title.png`,
};

export const oroMxDepositMethods = [
  { hot: true, id: 'bank', image: oroMxDepositAssets.bank, label: 'Online banking transfer' },
  { hot: true, id: 'paycash', image: oroMxDepositAssets.paycash, label: 'PayCash' },
  { hot: false, id: 'oxxo', image: oroMxDepositAssets.oxxo, label: 'OXXO' },
] as const;

export const oroMxDepositChannels = [
  { id: 'teemo', label: 'TeemoPay-VA' },
  { id: 'haituo', label: 'Haituo Payment' },
  { id: 'vortaq', label: 'VortaQPay-MXN' },
  { id: 'mgm', label: 'MGMPay-MXN' },
] as const;

export const oroMxDepositChips: OroMxDepositChip[] = [
  { amount: 50, bonus: 5 },
  { amount: 100, bonus: 10 },
  { amount: 200, bonus: 50 },
  { amount: 500, bonus: 150 },
  { amount: 1000, bonus: 400 },
  { amount: 2000, bonus: 1250 },
  { amount: 5000, bonus: 3000 },
  { amount: 10000 },
  { amount: 20000 },
];

export const oroMxLangFlags: Record<string, string> = {
  'en-US': `${skin}/menu/flag-en.png`,
  'es-MX': `${skin}/menu/flag-mx.webp`,
  'zh-CN': `${skin}/menu/flag-cn.png`,
  'zh-TW': `${skin}/menu/flag-tw.png`,
};

export const oroMxMenuAssets = {
  flagMx: `${skin}/menu/flag-mx.webp`,
  navAffiliate: `${skin}/menu/nav-affiliate.png`,
  navCasino: `${skin}/menu/nav-casino.png`,
  navPromo: `${skin}/menu/nav-promo.png`,
  navSupport: `${skin}/menu/nav-support.svg`,
  navTelegram: `${skin}/menu/nav-telegram.png`,
  navVip: `${skin}/menu/nav-vip.png`,
  promoCheckin: `${skin}/menu/promo-checkin.png`,
  promoScratch: `${skin}/menu/promo-scratch.png`,
  promoWheel: `${skin}/menu/promo-wheel.png`,
};

export const oroMxMenuPromos = [
  { id: 'checkin', image: oroMxMenuAssets.promoCheckin, to: '/sign-in' },
  { id: 'scratch', image: oroMxMenuAssets.promoScratch, to: '/promotions' },
  { id: 'wheel', image: oroMxMenuAssets.promoWheel, to: '/lottery-wheel' },
] as const;

export const oroMxMenuNav: Array<{
  icon: string;
  id: string;
  label: string;
  to?: string;
}> = [
  { id: 'vip', icon: oroMxMenuAssets.navVip, label: 'Sistema de niveles VIP', to: '/vip' },
  { id: 'promo', icon: oroMxMenuAssets.navPromo, label: 'promociones', to: '/promotions' },
  { id: 'affiliate', icon: oroMxMenuAssets.navAffiliate, label: 'Centro de afiliados', to: '/agent-share' },
  { id: 'telegram', icon: oroMxMenuAssets.navTelegram, label: 'Telegram' },
];

/** 源站 Casino 手风琴 9 行（含两个 Popular） */
export const oroMxMenuCasinoSubs = [
  { id: 'lobby', icon: 'icon-all', iconKind: 'svg' as const, label: 'Lobby', viewBox: '0 0 40 27' },
  { id: 'estudios', icon: 'icon-providers', iconKind: 'svg' as const, label: 'Estudios', viewBox: '0 0 24 24' },
  { id: 'favoritos', icon: 'icon-collect_id', iconKind: 'svg' as const, label: 'Favoritos', viewBox: '0 0 32 31' },
];

export const oroMxSignInAssets = {
  chest: oroMxSignSourceAssets.chest,
  chestLocked: oroMxSignSourceAssets.chestUnfinished,
  hero: oroMxSignSourceAssets.header,
  tab7day: oroMxSignSourceAssets.tab7day,
  tabTask: oroMxSignSourceAssets.tabTask,
};

export type OroMxSignStage = {
  action: string;
  actionKind: 'claim' | 'goBet' | 'muted';
  condition?: string;
  current?: number;
  day?: string;
  expired?: boolean;
  finished?: boolean;
  highlight?: boolean;
  id: string;
  name: string;
  status?: string;
  target?: number;
};

export const oroMxSignInTabs = [
  { id: 'seven', image: oroMxSignInAssets.tab7day, label: 'Tareas de registro de 7 días para recién llegados' },
  { id: 'daily', image: oroMxSignInAssets.tabTask, label: 'Tareas' },
  { id: 'chest', image: oroMxSignChestAssets.chestLarge, label: 'Cofres Bonus' },
] as const;

export const oroMxSignInStages: OroMxSignStage[] = [
  {
    id: 'd1',
    day: 'Día 1',
    name: 'Día 1 - Inicia sesión para registrarte',
    status: 'Completado',
    action: 'Reclamar recompensa',
    actionKind: 'claim',
    finished: true,
    highlight: true,
  },
  {
    id: 'd2',
    day: 'Día 2',
    name: 'Día 2 - Inicia sesión para registrarte',
    status: 'Tarea pendiente de reclamar',
    action: 'Actividad no iniciada',
    actionKind: 'muted',
  },
  {
    id: 'd3',
    day: 'Día 3',
    name: 'Día 3 - Apuesta 10 para registrarte',
    condition: 'Apuesta válida',
    current: 0,
    target: 10,
    action: 'Actividad no iniciada',
    actionKind: 'muted',
  },
  {
    id: 'd4',
    day: 'Día 4',
    name: 'Día 4 - Apuesta 20 para registrarte',
    condition: 'Apuesta válida',
    current: 0,
    target: 20,
    action: 'Actividad no iniciada',
    actionKind: 'muted',
  },
  {
    id: 'd5',
    day: 'Día 5',
    name: 'Día 5 - Apuesta 30 para registrarte',
    condition: 'Apuesta válida',
    current: 0,
    target: 30,
    action: 'Actividad no iniciada',
    actionKind: 'muted',
  },
  {
    id: 'd6',
    day: 'Día 6',
    name: 'Día 6 - Apuesta 50 para registrarte',
    condition: 'Apuesta válida',
    current: 0,
    target: 50,
    action: 'Actividad no iniciada',
    actionKind: 'muted',
  },
  {
    id: 'd7',
    day: 'Día 7',
    name: 'Día 7 - Apuesta 100 para registrarte',
    condition: 'Apuesta válida',
    current: 0,
    target: 100,
    action: 'Actividad no iniciada',
    actionKind: 'muted',
  },
];

export const oroMxDailyTasks: OroMxSignStage[] = [
  {
    id: 'invite',
    name: 'Invita a 1 usuario válido',
    current: 0,
    target: 1,
    action: 'Invita a tus amigos',
    actionKind: 'claim',
  },
  {
    id: 'bet100',
    name: 'Apostar 100 en tragamonedas',
    status: 'Tarea pendiente de reclamar',
    current: 0,
    target: 100,
    action: 'Ir a apostar',
    actionKind: 'claim',
  },
  {
    id: 'bet1000',
    name: 'Apostar 1000 en tragamonedas',
    status: 'Tarea pendiente de reclamar',
    current: 0,
    target: 1000,
    action: 'Ir a apostar',
    actionKind: 'claim',
  },
  {
    id: 'bet5000',
    name: 'Apostar 5000 en tragamonedas',
    status: 'Tarea pendiente de reclamar',
    current: 0,
    target: 5000,
    action: 'Ir a apostar',
    actionKind: 'claim',
  },
];

export const oroMxDiscountAssets = {
  claimedIcon: `${skin}/discount/claimed-icon.png`,
  jackpot: `${skin}/discount/jackpot.png`,
  rescue: `${skin}/discount/discount-7.png`,
  scratch: `${skin}/discount/discount-5.png`,
  wheel: `${skin}/discount/discount-6.png`,
};

export const oroMxDiscountTabs = [
  { id: 'permanent', label: 'Mis bonos' },
  { id: 'permanent-alt', label: 'permanentes' },
  { id: 'vip', label: 'Bonos VIP' },
  { id: 'prizes', label: 'Mis premios' },
] as const;

export const oroMxVipAssets = {
  faqArrow: `${skin}/vip/faq-arrow.png`,
  jackpot: `${skin}/float/jackpot.png`,
  shield: `${skin}/vip/shield.png`,
};

export const oroMxTeamAssets = {
  bonusCoins: `${skin}/team/bonus-coins.png`,
  chest: `${skin}/team/icon-chest.png`,
  coin: `${skin}/team/icon-coin.png`,
  deposit: `${skin}/team/deposit.png`,
  empty: `${skin}/team/empty.png`,
  friends: `${skin}/team/icon-friends.png`,
  goldBg: `${skin}/team/gold-bg.png`,
  hero: `${skin}/team/hero.png`,
  invitation: `${skin}/team/invitation.png`,
  levels: [
    `${skin}/team/level-1.png`,
    `${skin}/team/level-2.png`,
    `${skin}/team/level-3.png`,
    `${skin}/team/level-4.png`,
    `${skin}/team/level-5.png`,
  ] as const,
  planArt: `${skin}/team/plan-art.png`,
  rewardCoin: `${skin}/team/reward-coin.png`,
};

export const oroMxTeamSocials = [
  { id: 'whatsapp', icon: `${skin}/team/whatsapp.png` },
  { id: 'telegram', icon: `${skin}/team/telegram.png` },
  { id: 'facebook', icon: `${skin}/team/facebook.png` },
  { id: 'youtube', icon: `${skin}/team/youtube.png` },
  { id: 'instagram', icon: `${skin}/team/instagram.png` },
  { id: 'tiktok', icon: `${skin}/team/tiktok.png` },
] as const;

export const oroMxTeamHistoryDates = [
  { id: 'today', label: 'Hoy' },
  { id: 'three_days', label: '3 días' },
  { id: 'seven_days', label: '7 días' },
  { id: 'half_month', label: '15 días' },
  { id: 'one_month', label: '30 días' },
] as const;

export const oroMxTeamHistoryTypes = {
  received: { id: 'rebate_achieve', label: 'Registro de recompensas de reembolso' },
  retired: { id: 'rebate_payout', label: 'Registro de reembolsos del equipo' },
} as const;

export const oroMxTeamInfoDates = [
  { id: 'today', label: 'Hoy' },
  { id: 'three_days', label: '3 días' },
  { id: 'seven_days', label: '7 días' },
] as const;

export const oroMxTeamInfoLevels = [
  { id: 'all', label: 'Todos' },
  { id: '1', label: 'Nivel 1' },
  { id: '2', label: 'Nivel 2' },
  { id: '3', label: 'Nivel 3' },
] as const;

export const oroMxTeamInfoPeriods = [
  { id: 'today', label: 'Hoy' },
  { id: 'yesterday', label: 'Ayer' },
  { id: 'month', label: 'Este mes' },
] as const;

export const oroMxTeamTabs = [
  { icon: 'icon-control-panel', id: 'dashboard', label: 'Panel de control', viewBox: '0 0 22 22' },
  { icon: 'icon-bono', id: 'bonus', label: 'Mi Bono', viewBox: '0 0 26 23' },
  { icon: 'icon-promotion', id: 'referral', label: 'Bono de recomendación', viewBox: '0 0 22 22' },
  { icon: 'icon-rule', id: 'rules', label: 'Reglas', viewBox: '0 0 26 24' },
] as const;

export const oroMxTeamFaqs = [
  {
    q: '¿Qué es el programa de afiliados de Orocasino?',
    a: 'Invita amigos a registrarse y jugar para ganar comisiones y recompensas.',
  },
  {
    q: '¿Cuánto cuesta participar?',
    a: 'Participar en el programa de afiliados es totalmente gratis.',
  },
  {
    q: '¿Cuánto he ganado?',
    a: 'Puedes consultar tus ganancias acumuladas en el panel de control y en "Mis bonos".',
  },
  {
    q: '¿Más amigos o seguidores significan mejores beneficios?',
    a: 'Un amigo válido requiere depósito ≥100, apuesta ≥500 y teléfono vinculado. Más amigos válidos suben tu nivel.',
  },
];

export const oroMxTeamLive = [
  { avatar: `${skin}/team/av-cc7538.png`, name: 'lu*****88', amount: 'MXN2,828.95' },
  { avatar: `${skin}/team/av-67a4fd.png`, name: 'ac*****ng', amount: 'MXN1,852.38' },
  { avatar: `${skin}/team/av-67a4fd.png`, name: 'pl*****01', amount: 'MXN2,621.07' },
  { avatar: `${skin}/team/av-065768.png`, name: 'to*****ot', amount: 'MXN2,984.61' },
  { avatar: `${skin}/team/av-065768.png`, name: 'go*****n9', amount: 'MXN3,283.02' },
  { avatar: `${skin}/team/av-47245f.png`, name: 'te*****er', amount: 'MXN714.27' },
  { avatar: `${skin}/team/av-67a4fd.png`, name: 'ga*****22', amount: 'MXN2,857.31' },
  { avatar: `${skin}/team/av-67a4fd.png`, name: 'vi*****24', amount: 'MXN2,458.47' },
  { avatar: `${skin}/team/av-945744.png`, name: 'be*****er', amount: 'MXN864.55' },
  { avatar: `${skin}/team/av-065768.png`, name: 'wi*****r7', amount: 'MXN4,693.56' },
];

export const oroMxTeamStats = [
  { id: 'invite', info: false, label: 'Invitar amigos', value: '0' },
  { id: 'valid', info: true, label: 'Amigos válidos', value: '0' },
  { id: 'today-invite', info: false, label: 'Invitaciones de hoy', value: '0' },
  { id: 'today-valid', info: true, label: 'Válidos hoy', value: '0' },
  { id: 'today-deposit', info: false, label: 'Depósitos de hoy', value: 'MXN0.00' },
  { id: 'today-volume', info: true, label: 'Volumen de hoy', value: 'MXN0.00' },
] as const;

export const oroMxTeamBonusStats = [
  { id: 'register', title: 'Bono de registro recomendado de hoy' },
  { id: 'cashback', title: 'Reembolso de apuestas' },
  { id: 'bet-bonus', title: 'Bono de reembolso de apuestas' },
] as const;

export const oroMxTeamDepositRows = [
  { amount: '$50.00', bonus: '$0.50' },
  { amount: '$100.00', bonus: '$1.00' },
  { amount: '$150.00', bonus: '$1.50' },
  { amount: '$300.00', bonus: '$5.00' },
  { amount: '$500.00', bonus: '$10.50' },
  { amount: '$1,000.00', bonus: '$10.00' },
  { amount: '$2,000.00', bonus: '$20.50' },
  { amount: '$5,000.00', bonus: '$50.00' },
  { amount: '$10,000.00', bonus: '$100.50' },
] as const;

export const oroMxTeamLevels = [
  { level: 1, members: '1', minBetMinor: 100_000 },
  { level: 2, members: '5', minBetMinor: 1_000_000 },
  { level: 3, members: '10', minBetMinor: 10_000_000 },
  { level: 4, members: '20', minBetMinor: 100_000_000 },
  { level: 5, members: '30', minBetMinor: 1_000_000_000 },
] as const;

export const oroMxTeamSteps = [
  {
    n: '1',
    title: 'Comparte con amigos',
    desc: 'Comparte tu enlace de referido, código de referido o código QR con tus amigos.',
  },
  {
    n: '2',
    title: 'Tus amigos se registran y depositan',
    desc: 'Invita a tus amigos a registrarse en la plataforma Orocasino y a realizar su primer depósito.',
  },
  {
    n: '3',
    title: 'Gana hasta $99,999',
    desc: 'Obtén generosas comisiones cuando tus amigos realicen apuestas y depósitos.',
  },
] as const;

export type OroMxVipReward = {
  desc: string;
  id: string;
  image: string;
  lock: string;
  title: string;
  unlocked?: boolean;
};

export const oroMxVipRewards: OroMxVipReward[] = [
  {
    id: 'recompensas',
    title: 'Recompensas',
    lock: 'VIP 3',
    image: `${skin}/vip/reward-recompensas.png`,
    desc: 'Cada vez que alcances un nuevo nivel VIP, podrás reclamar las recompensas correspondientes. Cuanto mayor sea el nivel, mayores serán las recompensas, lo que hará que tu camino de crecimiento esté repleto de satisfacciones.',
  },
  {
    id: 'diario',
    title: 'Bono diario',
    lock: 'VIP 4',
    image: `${skin}/vip/reward-diario.png`,
    desc: 'Los miembros pueden recibir bonos de apuestas adicionales según el monto de sus apuestas diarias. Cuanto más apuestes, mayores serán las recompensas, lo que hará que tu participación diaria sea más valiosa.',
  },
  {
    id: 'ayuda',
    title: 'Ayuda',
    lock: 'VIP 5',
    image: `${skin}/vip/reward-ayuda.png`,
    desc: 'Cuando experimentes fluctuaciones a corto plazo, podrás recibir fondos de rescate VIP exclusivos que te ayudarán a mantener una experiencia estable y a disfrutar plenamente del juego.',
  },
  {
    id: 'mensual',
    title: 'Bono mensual',
    lock: 'VIP 7',
    image: `${skin}/vip/reward-mensual.png`,
    desc: 'Según tu nivel de membresía y actividad mensual, puedes recibir una generosa bonificación mensual. Gracias por tu continuo apoyo y compañía.',
  },
  {
    id: 'semanal',
    title: 'Bono semanal',
    lock: 'VIP 8',
    image: `${skin}/vip/reward-semanal.png`,
    desc: 'Gana bonificaciones semanales manteniéndote activo, haciendo que cada semana esté llena de sorpresas y emoción.',
  },
  {
    id: 'soporte',
    title: 'Soporte VIP',
    lock: 'VIP 9',
    image: `${skin}/vip/reward-soporte.png`,
    desc: 'Los miembros Premium disfrutarán de servicios exclusivos de gestión VIP, que incluyen respuesta rápida, procesamiento prioritario y asistencia personalizada para garantizar que sus necesidades se satisfagan con prontitud.',
  },
  {
    id: 'cumple',
    title: 'Cumpleaños',
    lock: 'VIP 10',
    image: `${skin}/vip/reward-cumple.png`,
    desc: 'Durante el mes de tu cumpleaños, te enviaremos nuestros más sinceros deseos y un regalo especial para celebrar este importante momento contigo.',
  },
  {
    id: 'exclusivos',
    title: 'Exclusivos',
    lock: 'VIP 11',
    image: `${skin}/vip/reward-exclusivos.png`,
    desc: 'Los miembros VIP pueden participar en actividades exclusivas, recibir descuentos limitados, bonos especiales y beneficios exclusivos de la plataforma, y ​​disfrutar de una experiencia única y distinguida.',
  },
  {
    id: 'fisicos',
    title: 'Regalos físicos',
    lock: 'Desbloqueado',
    unlocked: true,
    image: `${skin}/vip/reward-fisicos.png`,
    desc: 'Al alcanzar un nivel VIP determinado, tendrá la oportunidad de recibir recompensas físicas como productos digitales de alta gama, regalos de lujo y experiencias de viaje, que pondrán de manifiesto su estatus distinguido.',
  },
];

export type OroMxVipBenefitTab = {
  columns: string[];
  id: string;
  label: string;
  rows: string[][];
};

export const oroMxVipBenefitTabs: OroMxVipBenefitTab[] = [
  {
    id: 'upgrade',
    label: 'Bono por subir de nivel VIP',
    columns: ['VIP', 'Bono de nivel'],
    rows: [
      ['VIP 2', '1.00'],
      ['VIP 3', '2.00'],
      ['VIP 4', '3.00'],
      ['VIP 5', '5.00'],
      ['VIP 6', '7.00'],
      ['VIP 7', '10.00'],
      ['VIP 8', '30.00'],
      ['VIP 9', '100.00'],
      ['VIP 10', '500.00'],
      ['VIP 11', '1,000.00'],
    ],
  },
  {
    id: 'daily',
    label: 'Reembolso diario',
    columns: ['VIP', '% de reembolso', 'Premio máx'],
    rows: [
      ['VIP 2', '0.20%', '1'],
      ['VIP 3', '0.20%', '2'],
      ['VIP 4', '0.20%', '3'],
      ['VIP 5', '0.20%', '4'],
      ['VIP 6', '0.25%', '5'],
      ['VIP 7', '0.30%', '7'],
      ['VIP 8', '0.35%', '10'],
      ['VIP 9', '0.40%', '15'],
      ['VIP 10', '0.50%', '30'],
      ['VIP 11', '0.60%', '100'],
    ],
  },
  {
    id: 'monthly',
    label: 'Bono mensual fijo',
    columns: ['VIP', 'Apuestas válidas', 'Bono fijo'],
    rows: [
      ['VIP 5', '10,000', '7.7'],
      ['VIP 6', '20,000', '17.7'],
      ['VIP 7', '30,000', '27.7'],
      ['VIP 8', '40,000', '37.7'],
      ['VIP 9', '60,000', '57.7'],
      ['VIP 10', '80,000', '77.7'],
      ['VIP 11', '100,000', '177.7'],
    ],
  },
  {
    id: 'weekly',
    label: 'Reembolso semanal',
    columns: ['VIP', '% de reembolso', 'Premio máx.'],
    rows: [
      ['VIP 3', '1%', '5'],
      ['VIP 4', '2%', '10'],
      ['VIP 5', '3%', '20'],
      ['VIP 6', '4%', '40'],
      ['VIP 7', '5%', '65'],
      ['VIP 8', '6%', '100'],
      ['VIP 9', '7%', '200'],
      ['VIP 10', '8%', '500'],
      ['VIP 11', '9%', '1,000'],
    ],
  },
];

export const oroMxVipFaqs = [
  {
    q: '¿Qué es el Club VIP de Orocasino?',
    a: 'Supera tus expectativas y ten una experiencia exclusiva convirtiéndote en cliente VIP.',
  },
  {
    q: '¿Cuáles son los beneficios de unirse al Club VIP?',
    a: 'El Club VIP de Orocasino desbloquea los siguientes beneficios: - Información de primera mano directamente del equipo; - Bonificaciones semanales, mensuales, de cumpleaños y otras; - Mayor tasa de reembolso y devolución; - Eventos y batallas VIP especiales; - Gerente personal dedicado para resolver cualquier problema que puedas enfrentar de manera personalizada.',
  },
  {
    q: 'Me gustaría unirme al Club VIP, pero aún no cumplo con los requisitos del nivel. ¿Qué debo hacer?',
    a: 'Mantente activo diariamente, juega tus juegos favoritos, invita amigos y recarga tu cuenta con frecuencia. Estos factores te impulsarán a una experiencia VIP.',
  },
  {
    q: 'Soy miembro y aún no he recibido ninguna bonificación. ¿Por qué? ¿Cuándo se envían a los usuarios y con qué frecuencia?',
    a: 'La Bonificación VIP semanal se distribuye cada 7 días. Si cumples con los requisitos equivalentes. La Bonificación VIP mensual se distribuye cada 30 días.',
  },
  {
    q: '¿Cómo hacerse miembro del Club VIP?',
    a: 'Una vez que tu depósito y monto de apuesta alcancen los estándares especificados, te convertirás en el VIP correspondiente',
  },
  {
    q: '¿Qué afectará al bono semanal/mensual?',
    a: 'Lo único que afecta tus ganancias es tu actividad de juego: cuanto más juegas, más ganas. La excepción es la bonificación de cumpleaños, que obviamente se enviará al usuario de todos modos.',
  },
  {
    q: '¿Hay alguna oferta especial para los miembros del Club VIP?',
    a: 'Sí, hay muchos. Tu gerente te contará todo lo demás en detalle.',
  },
];

export const oroMxDepositTips = [
  'Después de completar tu depósito, participa en actividades y gana recompensas. ¡Actúa ya!',
  'Asegúrate de que el monto del depósito coincida con el pago. Cualquier diferencia puede retrasar o fallar la recarga.',
  'El monto mínimo por depósito y retiro es 50.00 MXN. Para más información, consulta nuestros términos y condiciones.',
];

export const oroMxEmptyAsset = `${skin}/team/empty.png`;

export const oroMxWithdrawAccountTabs = [
  { id: 'bank_card', label: 'Tarjeta bancaria' },
  { id: 'usdt', label: 'USDT' },
  { id: 'e_wallet', label: 'Monedero electrónico' },
  { id: 'pix', label: 'PIX' },
] as const;

export const oroMxUsdtChains = ['TRC-20', 'ERC-20', 'BEP-20'] as const;

export const oroMxNoticeTabs = [
  { id: 'platform', label: 'Plataforma' },
  { id: 'personal', label: 'Personal' },
] as const;

export const oroMxRecordDateFilters = [
  { id: 'today', label: 'Hoy' },
  { id: 'three_days', label: '3 días' },
  { id: 'seven_days', label: '7 días' },
] as const;

export const oroMxTxTypeFilters = [
  { id: 'all', label: 'Todo' },
  { id: 'deposit', label: 'Depósito' },
  { id: 'withdraw', label: 'Retiro' },
] as const;

export const oroMxAllTypeFilters = [{ id: 'all', label: 'Todo' }] as const;

export const oroMxRewardAssets = {
  type1: `${skin}/reward/type1.png`,
  type2: `${skin}/reward/type2.png`,
  type3: `${skin}/reward/type3.png`,
  type4: `${skin}/reward/type4.png`,
  type5: `${skin}/reward/type5.png`,
  type6: `${skin}/reward/type6.png`,
  type7: `${skin}/reward/type7.png`,
};

export const oroMxRewardClaims = [
  { amount: '$0.00', icon: oroMxRewardAssets.type7, name: 'Bono de regalo' },
  { amount: '$0.00', icon: oroMxRewardAssets.type4, name: 'Bono de nivel' },
  { amount: '$0.00', icon: oroMxRewardAssets.type2, name: 'Ofertas de eventos' },
  { amount: '$0.00', icon: oroMxRewardAssets.type6, name: 'Recompensa de misión' },
  { amount: '$0.00', icon: oroMxRewardAssets.type5, name: 'Ruleta gratis' },
  { amount: '$0.00', icon: oroMxRewardAssets.type1, name: 'Cinco bendiciones' },
  { amount: '$0.00', icon: oroMxRewardAssets.type6, name: 'Recompensas de referido' },
  { amount: '$0.00', icon: oroMxRewardAssets.type7, name: 'Código de reclamo' },
  { amount: '$0.00', icon: oroMxRewardAssets.type3, name: 'Reembolso por depósito' },
  { amount: '$0.00', icon: oroMxRewardAssets.type3, name: 'Reembolso de juego' },
] as const;

export const oroMxTutorialAssets = {
  hand: `${skin}/tutorial/hand.png`,
  step1: `${skin}/tutorial/step1.png`,
  step2: `${skin}/tutorial/step2.png`,
  step3: `${skin}/tutorial/step3.png`,
};

export const oroMxTutorialSteps = [
  {
    desc: 'Abre Safari en tu teléfono.',
    id: 'step1',
    image: oroMxTutorialAssets.step1,
    label: 'Paso 1',
    showHand: false,
    title: '1. Abre el sitio en Safari.',
  },
  {
    desc: 'Abre Safari en tu teléfono.',
    id: 'step2',
    image: oroMxTutorialAssets.step2,
    label: 'Paso 2',
    showHand: true,
    title: '2. Abre el sitio en Safari.',
  },
  {
    desc: 'Toca "Agregar a pantalla de inicio".',
    id: 'step3',
    image: oroMxTutorialAssets.step3,
    label: 'Paso 3',
    showHand: false,
    title: '3. Agregar a la pantalla de inicio.',
  },
] as const;
